import Autoplay from "embla-carousel-autoplay";
import { Carousel } from "~/components/ui/Carousel";
export default function AutoplayCarousel(props: any) {
  return (
    <Carousel
      {...props}
      plugins={[Autoplay({ playOnInit: true, delay: 3000 })]}
    >
      {props.children}
    </Carousel>
  );
}
